import React, { useContext } from 'react';
import { Route } from 'react-router';
import { Switch, Redirect } from 'react-router-dom';

import { AuthContext } from '../contexts/AuthContext';
import { NavContext, NavRoutes } from '../contexts/NavContext';
import { UserContext } from '../contexts/UserContext';

import {
    HomePage,
    LoginPage,
    BookedPage,
    NotFoundPage,
    ForbiddenPage
} from '../pages';

const ProtectedRoute = ({ ...props }) => {

    const {
        isAuthenticated,
        getAccountInfo
    } = useContext(AuthContext);

    const {
        getCurrentUserInfo
    } = useContext(UserContext);

    const accountInfo = getAccountInfo();
    const userInfo = getCurrentUserInfo();
    if (isAuthenticated() && userInfo) {
        if (props.path === NavRoutes.Login) {
            return <Redirect to={NavRoutes.Home} />;
        } else {
            if (userInfo.hasAlreadyBooked
                && props.path !== NavRoutes.Booked) {
                return <Redirect to={NavRoutes.Booked} />;
            } else {
                return <Route {...props} />;
            }
        }
    } else {
        return <Redirect to={NavRoutes.Login} />;
    }
}

export const Routes = ({ ...props }) => {
    const { menuItems } = useContext(NavContext);

    return (
        <Switch>

            {menuItems && menuItems.map((item, index) => {
                if (item.isProtected) {
                    return <ProtectedRoute key={index} exact path={item.routePath} component={item.component} />
                } else {
                    return <Route key={index} exact path={item.routePath} component={item.component} />
                }
            })}

            <ProtectedRoute exact path={NavRoutes.Home} component={HomePage} />

            <ProtectedRoute exact path={NavRoutes.Booked} component={BookedPage} />

            <Route exact path={NavRoutes.Login} component={LoginPage} />

            <Route exact path={NavRoutes.Forbidden} component={ForbiddenPage} />

            <Route component={NotFoundPage} />

        </Switch>
    );
}